module.exports = __webpack_public_path__ + "img/semaphoreInactiveLocked.4f88bafd.png";